import * as React from "react";
import clsx from "clsx";

type PlaneIconProps = React.SVGProps<SVGSVGElement> & {
  className?: string;
};

const PlaneIcon = ({ className, ...props }: PlaneIconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 477.5 386.05" className={clsx(className)} {...props}>
    <defs>
      <style>
        {".cls-2{fill:#9fc6ff}.cls-3{fill:#7fa2cc}.cls-4{fill:#6b8daf}"}
      </style>
    </defs>
    <title>{"NoTextLogo"}</title>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path
          d="m0 139.89 94.7 5.06 166.44-63.24-151.98-14.12L0 139.89z"
          style={{
            fill: "#92b8dd",
          }}
        />
        <path
          d="m429.06 317.37-163.38 68.68-55.67-117.84L335.8 141.7l93.26 175.67zM261.34 81.69l31.92 84.94-91.56 83.15-13.01 39.76L94.7 144.95l166.64-63.26z"
          className="cls-2"
        />
        <path
          d="m210.01 268.21-20.96 20.97 12.45-40.13 8.51 19.16z"
          className="cls-3"
        />
        <path
          d="m293.15 166.28 4.99 13.26-88.13 88.67-8.67-18.8 91.81-83.13z"
          className="cls-4"
        />
        <path
          d="m331.47 132.3-33.26 46.99-5.06-13.01 38.32-33.98z"
          style={{
            fill: "#4d6477",
          }}
        />
        <path
          d="m335.8 141.7-37.59 37.59 33.26-46.99 4.33 9.4z"
          style={{
            fill: "#3d515e",
          }}
        />
        <path
          d="M477.5 0 331.47 132.3l4.33 9.4L477.5 0z"
          style={{
            fill: "#28333a",
          }}
        />
        <path
          d="M429.06 317.37 335.8 141.7 477.5 0l-48.44 317.37zM261.34 81.69 109.53 67.96 477.5 0 261.34 81.69z"
          className="cls-3"
        />
        <path
          d="M293.15 166.28 477.5 0 261.34 81.69l31.81 84.59z"
          className="cls-4"
        />
      </g>
    </g>
  </svg>
);
export default PlaneIcon;
